import React, { useState } from "react";
import { ThumbsUp, ThumbsDown, Copy, Check } from "lucide-react";
import { cn } from "@/lib/utils";
import useChatStore from "@/stores/useChatStore";

function FeedbackButtons({ messageId, messageContent, className, initialFeedback = null }) {
  const [copying, setCopying] = useState(false);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [feedback, setFeedback] = useState(initialFeedback);
  const [showFeedbackMessage, setShowFeedbackMessage] = useState(false);
  const submitFeedback = useChatStore((store) => store.submitFeedback);

  const handleFeedback = (type) => {
    if (feedback === type) return;

    setFeedback(type);
    setShowFeedbackMessage(true);
    setTimeout(() => setShowFeedbackMessage(false), 1000);
    submitFeedback(messageId, type);
  };

  const handleCopy = () => {
    const textToCopy = messageContent || "";
    if (!textToCopy) return;

    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopying(true);
      setTimeout(() => setCopying(false), 1000);
    });
  };

  const showTooltip = (tooltipId) => {
    setActiveTooltip(tooltipId);
  };

  const hideTooltip = () => {
    setActiveTooltip(null);
  };

  return (
    <div className={cn("flex items-center gap-2 mt-1", className)}>
      <div className="relative">
        <button
          onClick={handleCopy}
          className="p-1.5 rounded hover:bg-gray-100 transition-colors text-gray-400 flex items-center gap-1"
          aria-label="Sao chép"
          onMouseEnter={() => showTooltip("copy")}
          onMouseLeave={hideTooltip}
        >
          {copying ? (
            <>
              <Check size={16} className="text-green-500" />
              <span className="text-xs text-green-500">Đã sao chép</span>
            </>
          ) : (
            <Copy size={16} />
          )}
        </button>
        {activeTooltip === "copy" && !copying && (
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 text-xs text-white bg-gray-800 rounded shadow-md whitespace-nowrap z-10">Sao chép nội dung</div>
        )}
      </div>

      <div className="relative">
        <button
          onClick={() => handleFeedback("positive")}
          className={cn("p-1.5 rounded hover:bg-gray-100 transition-colors", feedback === "positive" ? "text-blue-500" : "text-gray-400")}
          aria-label="Phản hồi tốt"
          onMouseEnter={() => showTooltip("positive")}
          onMouseLeave={hideTooltip}
        >
          <ThumbsUp size={16} />
        </button>
        {activeTooltip === "positive" && (
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 text-xs text-white bg-gray-800 rounded shadow-md whitespace-nowrap z-10">Phản hồi tốt</div>
        )}
      </div>

      <div className="relative">
        <button
          onClick={() => handleFeedback("negative")}
          className={cn("p-1.5 rounded hover:bg-gray-100 transition-colors", feedback === "negative" ? "text-red-500" : "text-gray-400")}
          aria-label="Phản hồi không tốt"
          onMouseEnter={() => showTooltip("negative")}
          onMouseLeave={hideTooltip}
        >
          <ThumbsDown size={16} />
        </button>
        {activeTooltip === "negative" && (
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 text-xs text-white bg-gray-800 rounded shadow-md whitespace-nowrap z-10">Phản hồi không tốt</div>
        )}
      </div>

      {feedback && showFeedbackMessage && <span className="text-xs text-gray-500">{feedback === "positive" ? "Cảm ơn phản hồi của bạn!" : "Cảm ơn, chúng tôi sẽ cải thiện!"}</span>}
    </div>
  );
}

export default FeedbackButtons;
